import {commitMutation, graphql} from 'react-relay'
import type {Environment} from 'relay-runtime'

import type {addReactionMutation_ReactionGroups$data} from './__generated__/addReactionMutation_ReactionGroups.graphql'
import type {
  ReactionContent,
  RemoveReactionInput,
  removeReactionMutation,
  removeReactionMutation$data,
} from './__generated__/removeReactionMutation.graphql'

export function removeReactionMutation({
  environment,
  input: {subject, content},
  onError,
  onCompleted,
  updatedReactionGroups,
  viewer,
}: {
  environment: Environment
  input: {subject: string; content: ReactionContent}
  onError?: (error: Error) => void
  onCompleted?: (response: removeReactionMutation$data) => void
  updatedReactionGroups: addReactionMutation_ReactionGroups$data
  viewer: {id: string; login: string}
}) {
  const inputHash: RemoveReactionInput = {
    subjectId: subject,
    content,
  }

  return commitMutation<removeReactionMutation>(environment, {
    mutation: graphql`
      mutation removeReactionMutation($input: RemoveReactionInput!) @raw_response_type {
        removeReaction(input: $input) {
          subject {
            id
            ...ReactionViewerGroups
          }
          reaction {
            id
            user {
              login
              id
            }
          }
        }
      }
    `,
    variables: {
      input: inputHash,
    },
    optimisticResponse: {
      removeReaction: {
        subject: {
          id: subject,
          reactionGroups: (updatedReactionGroups.reactionGroups || []).map(a => {
            return {
              content: a.content,
              viewerHasReacted: a.content === content ? false : a.viewerHasReacted,
              reactors: {
                edges: a.reactors.edges
                  ? a.reactors.edges.map(r => {
                      return {
                        node: {
                          id: r?.node.__typename === '%other' ? '' : r?.node.id || '',
                          login: r?.node.__typename === '%other' ? '' : r?.node.login,
                          __typename: 'User',
                          __isNode: 'User',
                        },
                      }
                    })
                  : [],
                totalCount:
                  a.content === content && a.viewerHasReacted ? a.reactors.totalCount - 1 : a.reactors.totalCount,
              },
            }
          }),
          __isReactable: 'IssueComment',
          __typename: 'IssueComment',
        },
        reaction: {
          id: '',
          user: {
            login: viewer.login,
            id: viewer.id,
          },
        },
      },
    },
    onError: error => onError && onError(error),
    onCompleted: response => onCompleted && onCompleted(response),
  })
}
